import { render } from "./AIPlaceholder.vue?vue&type=template&id=27cdab10&scoped=true"
import script from "./AIPlaceholder.vue?vue&type=script&lang=js"
export * from "./AIPlaceholder.vue?vue&type=script&lang=js"

import "./AIPlaceholder.vue?vue&type=style&index=0&id=27cdab10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cdab10"]])

export default __exports__